const allowedRoll = (...allowedRoles) => {
  let Suser = JSON.parse(localStorage.getItem("userIn"));
  function isPositive(value) {
    return value === Suser.roles;
  }
  let filtered = allowedRoles.filter(isPositive);
  return filtered.length > 0 ? false : true;
};

export default allowedRoll;
